"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../Button"));
const range_utils_1 = require("./range-utils");
const SIBLING_COUNT = 3;
class Pagination extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.isFirstActive = () => {
            const { activePage } = this.props;
            return activePage === 1;
        };
        this.isLastActive = () => {
            const { activePage, totalPages } = this.props;
            return activePage === totalPages;
        };
    }
    handleChange(navigation) {
        const { onPageChange, totalPages, activePage } = this.props;
        let page;
        switch (navigation) {
            case 'first':
                page = range_utils_1.FIRST_PAGE;
                break;
            case 'previous':
                page = activePage - range_utils_1.ONE_PAGE;
                break;
            case 'next':
                page = activePage + range_utils_1.ONE_PAGE;
                break;
            case 'last':
                page = totalPages;
                break;
            default:
                page = navigation;
        }
        onPageChange(page);
    }
    renderRange() {
        const { totalPages, activePage, disabled } = this.props;
        const range = range_utils_1.getRange(activePage, totalPages, SIBLING_COUNT);
        return range.map((pageItemLabel, index) => {
            return (react_1.default.createElement(Button_1.default, { disabled: pageItemLabel === range_utils_1.ELLIPSIS || disabled, key: pageItemLabel + index, onClick: () => this.handleChange(pageItemLabel), variant: activePage === pageItemLabel ? 'primary' : 'basic' }, pageItemLabel));
        });
    }
    render() {
        const { disabled } = this.props;
        const isFirstActive = this.isFirstActive();
        const isLastActive = this.isLastActive();
        return (react_1.default.createElement(Button_1.default.Group, null,
            react_1.default.createElement(Button_1.default, { disabled: isFirstActive || disabled, onClick: () => this.handleChange('first'), variant: 'basic' }, "\u00AB"),
            react_1.default.createElement(Button_1.default, { disabled: isFirstActive || disabled, onClick: () => this.handleChange('previous'), variant: 'basic' }, "\u27E8"),
            this.renderRange(),
            react_1.default.createElement(Button_1.default, { disabled: isLastActive || disabled, onClick: () => this.handleChange('next'), variant: 'basic' }, "\u27E9"),
            react_1.default.createElement(Button_1.default, { disabled: isLastActive || disabled, onClick: () => this.handleChange('last'), variant: 'basic' }, "\u00BB")));
    }
}
Pagination.defaultProps = {
    disabled: false
};
exports.Pagination = Pagination;
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map